export const TRADING_PARTNERS_GET = 'TRADING_PARTNERS_GET';
export const TRADING_PARTNERS_GET_SUCCESS = 'TRADING_PARTNERS_GET_SUCCESS';
export const TRADING_PARTNERS_GET_FAILURE = 'TRADING_PARTNERS_GET_FAILURE';
export const TRADING_PARTNERS_RESET ='TRADING_PARTNERS_STORE_RESET'



